// extracted by mini-css-extract-plugin
export default {"statsContainer":"styles_statsContainer__bJHLw","resultsStats":"styles_resultsStats__l1yt7"};